import simpleParallax from 'simple-parallax-js';

class Parallax {
  constructor(els) {
    this.els = els
    this.initialize()
  }

  initialize() {
    let container

    for (let i = 0; i < this.els.length; i++) {
      const image = this.els[i];
      
      if (image.closest('.overlay').classList.contains('js-overlay-discover')) {
        container = image.closest('.js-overlay-discover .overlay__item')
      } else if(image.closest('.overlay').classList.contains('js-overlay-stories')) {
        container = image.closest('.js-overlay-stories .overlay__item')
      } else {
        container = container = image.closest('.js-overlay .overlay__item')
      }
    }

    this.instance = new simpleParallax(this.els, {
      customContainer: container,
      overflow: true,
      // delay: .3,
	    // transition: 'cubic-bezier(0,0,0,1)'
    })
  }
}

export default Parallax 
